<form [formGroup]="salesTaxClassForm" (ngSubmit)="submit()">
  <div class="row">
    <div class="col-md-6 mb-3">
      <input-field
        [label]="'Code'"
        [type]="'text'"
        [placeholder]="'Enter Code'"
        [required]="true"
        formControlName="code"
        [requiredLabel]="true"
        [errormessage]="'Code is required'"
      ></input-field>
    </div>
    <div class="col-md-6 mb-3">
      <input-field
        [label]="'Description'"
        [type]="'text'"
        [placeholder]="'Enter Description'"
        [required]="true"
        formControlName="description"
        [requiredLabel]="true"
        [errormessage]="'Description is required'"
      ></input-field>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="taxCategoriesList()"
        [label]="'Tax Category'"
        [placeholder]="'Select Tax Category'"
        formControlName="taxCategoryId"
        [clearable]="true"
        [required]="true"
        [errormessage]="'Tax Category is required'"
      ></generic-dropdown>
    </div>
    <div class="col-md-6 mb-3">
      <generic-dropdown
        [items]="taxAuthoritiesList()"
        [label]="'Tax Authorities'"
        [placeholder]="'Select Tax Authorities'"
        [errormessage]="'Tax Authorities are required and must be maximum 3'"
        formControlName="taxAuthorityIds"
        [multiselect]="true"
        [allowSearch]="true"
        [clearable]="true"
      ></generic-dropdown>
    </div>
  </div>
</form>
